<template>
  <fp-field :keys="$props">
    <v-menu max-width="460" offset-y>
      <template v-slot:activator="{ on }">
        <fp-btn
            class="month-picker-button"
            v-on="on"
            :error="hasError"
            :block="block"
            x-large>
          <slot name="label"/>
        </fp-btn>
      </template>
      <v-date-picker
          landscape
          :ref="INPUT_REF"
          :min="minDate"
          :max="maxDate"
          @input="onInput()"
          v-model="model"
          type="month"/>
    </v-menu>
  </fp-field>
</template>
<script lang="ts">
import {Vue, Component, Prop, Inject} from 'vue-property-decorator';
import FpField from '@/components/fpComponents/FpField/FpField.vue';
import {VDatePicker, VMenu} from 'vuetify/lib';

interface IForm {
  hasError: boolean;
  form: any | undefined;
  resetValidation(): void;
  validate(): boolean;
}

@Component({
  components: {FpField, VMenu, VDatePicker,},
})
export default class FpMonthPicker extends Vue implements IForm {
  public readonly INPUT_REF: string = 'INPUT_REF';

  @Prop({required: true,})
  public readonly value!: string | null;

  @Prop({required: false,})
  public readonly label!: string;

  @Prop({required: false,})
  public readonly minDate!: string;

  @Prop({required: false,})
  public readonly maxDate!: string;

  @Prop({required: false, default: false,})
  public readonly required!: boolean;

  @Prop()
  public readonly block!: boolean;

  @Inject({from: 'form', default: () => null, })
  public form!: any;

  hasError: boolean = false

  get model(): string | null {
    return this.value;
  }

  set model(newValue: string | null) {
    this.$emit('input', newValue);
  }

  onInput(): void {
    this.hasError = true
  }

  resetValidation(): void {
    this.hasError = false
  }

  validate(): boolean {
    this.hasError = this.required && !this.value;
    return !this.hasError;
  }

  created() {
    if (this.form) {
      this.form.register(this);
    }
  }

  destroyed() {
    if (this.form) {
      this.form.unregister(this);
    }
  }
}
</script>
<style scoped lang="scss">
.month-picker-button {
  height: 56px !important;
}
</style>
